(() => {
  const BACKEND_URL = "https://refunds-app-deb5202df0df.herokuapp.com";

  function $(sel) { return document.querySelector(sel); }

  function updateVisibility(mode) {
    $("[data-pm-card]").style.display = mode === 'card' ? 'block' : 'none';
    $("[data-pm-phone]").style.display = mode === 'phone' ? 'block' : 'none';
    $("[data-pm-email]").style.display = mode === 'email' ? 'block' : 'none';
  }

  // Generate barcode image URL from membership number
  function generateBarcodeUrl(membershipNumber) {
    const encodedNumber = encodeURIComponent(membershipNumber);
    return `https://barcode.tec-it.com/barcode.ashx?data=${encodedNumber}&code=Code128&dpi=96&dataseparator=`;
  }

  // Hide loading state and show appropriate state
  function hideLoadingState() {
    const loadingState = $("#pmLoadingState");
    if (loadingState) {
      loadingState.style.display = "none";
    }
  }

  // Show status text with inline spinner (e.g. "Linking account")
  function setStatusWithSpinner(text) {
    const el = $("#pmStatus");
    if (el) {
      el.innerHTML = `<span class="plusmore-status-spinner" aria-hidden="true"></span>${escapeHtml(text)}`;
    }
  }

  function escapeHtml(s) {
    const div = document.createElement("div");
    div.textContent = s;
    return div.innerHTML;
  }

  // Show verification form (unlinked state)
  function showVerificationForm() {
    hideLoadingState();
    const unlinkedState = $("#pmUnlinkedState");
    if (unlinkedState) {
      unlinkedState.style.display = "block";
    }
  }

  // Check if account is linked and display linked state
  async function checkLinkedState() {
    try {
      const customerId = window.Shopify?.customer?.id;
      const shop = window.Shopify?.shop;

      if (!customerId || !shop) {
        showVerificationForm();
        return;
      }

      const resp = await fetch(`${BACKEND_URL}/api/preferences/${shop}/customer/${customerId}`);
      
      if (!resp.ok) {
        showVerificationForm();
        return;
      }

      const customerData = await resp.json();

      const plusMoreNumber = customerData.metafields?.["plus-more-number"] || 
                            customerData.metafields?.["plus_more_number"] ||
                            customerData.metafields?.["Plus More Number"] ||
                            null;

      // Source of truth: if plus_more_number metafield exists, the customer IS linked
      if (!plusMoreNumber) {
        showVerificationForm();
        return;
      }

    
      const tags = Array.isArray(customerData.tags) ? customerData.tags : [];
      
      // Check if customer has the required tags
      const hasPlusMoreTag = tags.some(tag => {
        const normalizedTag = String(tag).toLowerCase().trim();
        return normalizedTag === "plus-more" || 
               normalizedTag === "plusmoreverified" ||
               normalizedTag === "plusmore" ||
               tag === "plus-more" || 
               tag === "PlusMoreVerified";
      });

      // If metafield exists but tags are missing, auto-write both tags
      if (!hasPlusMoreTag) {
        const updatedTags = [...tags, "plus-more", "PlusMoreVerified"];
        try {
          await fetch(`${BACKEND_URL}/api/preferences/${shop}/customer/${customerId}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ tags: updatedTags }),
          });
        } catch (tagErr) {
          console.warn("[PlusMore Frontend] Failed to auto-write missing tags:", tagErr);
        }
      }

      // Display linked state
      showLinkedState(plusMoreNumber);
    } catch (err) {
      showVerificationForm();
    }
  }

  // Show the linked state with barcode
  function showLinkedState(membershipNumber) {
    hideLoadingState();
    const unlinkedState = $("#pmUnlinkedState");
    const linkedState = $("#pmLinkedState");
    const membershipDisplay = $("#pmMembershipNumberDisplay");
    const barcodeImg = $("#pmBarcodeImg");

    if (!linkedState) {
      console.error("[PlusMore Frontend] Missing linked state element");
      showVerificationForm();
      return;
    }

    // Hide unlinked state, show linked state
    if (unlinkedState) {
      unlinkedState.style.display = "none";
    }
    linkedState.style.display = "block";

    // Set membership number
    if (membershipDisplay) {
      membershipDisplay.textContent = membershipNumber;
    }

    // Generate and set barcode
    if (barcodeImg) {
      const barcodeUrl = generateBarcodeUrl(membershipNumber);
      barcodeImg.src = barcodeUrl;
      barcodeImg.alt = `Barcode for ${membershipNumber}`;
    }
  }

  function init() {
    const modeSelect = $("#pmModeSelect");
    if (!modeSelect) return;

    let cachedIdNumber = null;
    let cachedMembershipNumber = null;
    let cachedDuplicateCheck = null;
    let duplicateCheckPromise = null; 


    // Check linked state on page load
    checkLinkedState();

    // Set Default
    updateVisibility(modeSelect.value);

    modeSelect?.addEventListener("change", (e) => {
      updateVisibility(e.target.value);
      $("#pmStatus").textContent = "";
    });

    // Handle Lookup (Link +more profile)
    $("#pmCheckBtn")?.addEventListener("click", async () => {
      const mode = modeSelect.value;
      const val = mode === 'card' ? $("#pmCardNo").value : (mode === 'phone' ? $("#pmPhoneNumber").value : $("#pmEmail").value);

      if (!val) {
        $("#pmStatus").textContent = "Please enter your details.";
        return;
      }

      try {
        $("#pmCheckBtn").disabled = true;
        $("#pmStatus").textContent = "Searching for account...";

        const shop = window.Shopify.shop;
        const type = mode === 'phone' ? 'MSISDN' : (mode === 'email' ? 'EMAIL' : 'CARD');
        
        const resp = await fetch(`${BACKEND_URL}/api/plusmore/${shop}/status?idNumber=${val}&idType=${type}&lookupOnly=true`);
        const result = await resp.json();
        
        // Check for errors first
        if (!result.success) {
          // Only show specific message if it's "Account not found", otherwise show generic
          const errorText = result.error || result.Response?.ResponseDescription;
          const isAccountNotFound = errorText && (errorText.includes("Account not found") || errorText.includes("does not exist"));
          
          if (isAccountNotFound) {
             $("#pmStatus").textContent = "Account not found.";
          } else {
             $("#pmStatus").textContent = "An error occurred. Please try again later.";
          }
          return;
        }
        
        // Response shape differs by lookup type:
        // CARD: returns ResponseDescription.CustomerDetails with IDNo and Cards[]
        // MSISDN/EMAIL: returns profile_values[] with user_id_number
        const responsePayload = result?.data?.Response || {};
        const customerDetails = responsePayload?.ResponseDescription?.CustomerDetails || null;

        if (type === 'CARD' && customerDetails) {
          // Card lookup — IDNo is used for verification; card number is the membership number
          cachedIdNumber = customerDetails.IDNo || null;
          const cards = customerDetails.Cards || responsePayload?.ResponseDescription?.Cards || [];
          cachedMembershipNumber = (cards.length > 0 && cards[0]?.card_number)
            ? cards[0].card_number
            : val; // fallback to what the user typed

          if (cachedIdNumber) {
            $("#pmIdVerificationStep").style.display = "block";
            $("#pmCheckBtn").style.display = "none";
            $("#pmVerifyIdBtn").style.display = "block";
            $("#pmResetBtn").style.display = "block";
            $("#pmStatus").textContent = "Account found. Please verify your ID or Passport Number.";
            modeSelect.disabled = true;

            // Run duplicate check in background (membership number already known)
            cachedDuplicateCheck = null;
            duplicateCheckPromise = (async function () {
              try {
                const customerId = window.Shopify?.customer?.id;
                if (!customerId) return null;
                const checkResp = await fetch(
                  `${BACKEND_URL}/api/plusmore/${shop}/customer/${customerId}/check-duplicate?plusMoreNumber=${encodeURIComponent(cachedMembershipNumber)}`
                );
                if (!checkResp.ok) return null;
                const data = await checkResp.json();
                const dupeResult = { exists: !!data.exists, checkFailed: !!data.checkFailed };
                cachedDuplicateCheck = dupeResult;
                return dupeResult;
              } catch (e) {
                console.warn("[PlusMore Frontend] Duplicate check failed:", e);
                return null;
              }
            })();
          } else {
            $("#pmStatus").textContent = "Account not found. Please check your details and try again.";
          }
        } else {
          // MSISDN / EMAIL lookup — response contains profile_values with user_id_number
          const profileValues = responsePayload?.profile_values || [];
          const firstProfile = profileValues[0];
          cachedIdNumber = firstProfile?.user_id_number || null;

          if (cachedIdNumber) {
            $("#pmIdVerificationStep").style.display = "block";
            $("#pmCheckBtn").style.display = "none";
            $("#pmVerifyIdBtn").style.display = "block";
            $("#pmResetBtn").style.display = "block";
            $("#pmStatus").textContent = "Account found. Please verify your ID or Passport Number.";
            modeSelect.disabled = true;
            // Pre-fetch full profile and run duplicate check in background.
            cachedMembershipNumber = null;
            cachedDuplicateCheck = null;
            duplicateCheckPromise = (async function () {
              try {
                const fullProfileResp = await fetch(`${BACKEND_URL}/api/plusmore/${shop}/status?idNumber=${val}&idType=${type}`);
                const fullProfileResult = await fullProfileResp.json();
                if (!fullProfileResult.success) return null;

                const response = fullProfileResult.data?.Response || {};
                const profileValuesFull = response.profile_values || [];
                const cards = response.cards || [];

                let membershipNumber = null;
                const cardNoEntry = profileValuesFull.find(pv =>
                  pv.type === "plus_more_card_no" || pv.type === "card_number" || pv.type === "membership_number"
                );
                if (cardNoEntry?.value) membershipNumber = String(cardNoEntry.value);
                else if (cards.length > 0 && cards[0]?.card_number) membershipNumber = cards[0].card_number;
                else {
                  const idEntry = profileValuesFull.find(pv => pv.type === "id");
                  if (idEntry?.value) membershipNumber = String(idEntry.value);
                  else membershipNumber = response.guid || response.customer_id || null;
                }

                if (!membershipNumber) return null;
                cachedMembershipNumber = membershipNumber;

                const customerId = window.Shopify?.customer?.id;
                if (!customerId) return null;

                const checkResp = await fetch(
                  `${BACKEND_URL}/api/plusmore/${shop}/customer/${customerId}/check-duplicate?plusMoreNumber=${encodeURIComponent(membershipNumber)}`
                );
                if (!checkResp.ok) return null;
                const data = await checkResp.json();
                const dupeResult = { exists: !!data.exists, checkFailed: !!data.checkFailed };
                cachedDuplicateCheck = dupeResult;
                return dupeResult;
              } catch (e) {
                console.warn("[PlusMore Frontend] Pre-fetch/duplicate check failed:", e);
                return null;
              }
            })();
          } else {
            $("#pmStatus").textContent = "Account not found. Please check your details and try again.";
          }
        }
      } catch (err) {
        $("#pmStatus").textContent = "An error occurred. Please try again later.";
      } finally {
        $("#pmCheckBtn").disabled = false;
      }
    });

    // Handle ID Verification
    $("#pmVerifyIdBtn")?.addEventListener("click", async () => {
      const enteredId = $("#pmIdNumber").value.trim();
      
      if (!enteredId) {
        $("#pmStatus").textContent = "Please enter your ID or Passport Number.";
        return;
      }
      
      if (enteredId !== cachedIdNumber) {
        $("#pmStatus").textContent = "ID or Passport Number does not match our records.";
        return;
      }

      try {
        $("#pmVerifyIdBtn").disabled = true;
        setStatusWithSpinner("Linking account");

        const customerId = window.Shopify.customer.id;
        const shop = window.Shopify.shop;
        const mode = modeSelect.value;
        const lookupVal = mode === 'card' ? $("#pmCardNo").value : (mode === 'phone' ? $("#pmPhoneNumber").value : $("#pmEmail").value);
        const type = mode === 'phone' ? 'MSISDN' : (mode === 'email' ? 'EMAIL' : 'CARD');

        // Wait for background duplicate check to finish (if it was started).
        let duplicateResult = null;
        if (duplicateCheckPromise) {
          try {
            duplicateResult = await duplicateCheckPromise;
          } catch (e) {
            console.warn("[PlusMore Frontend] Duplicate pre-check awaited with error:", e);
          }
        }

        if (duplicateResult && duplicateResult.exists) {
           $("#pmStatus").textContent = "This PlusMore number is already linked to another account";
           return;
        }


        // Use cached membership number from background pre-fetch if available; otherwise fetch full profile now
        let membershipNumber = cachedMembershipNumber || null;
        if (!membershipNumber) {
          const fullProfileResp = await fetch(`${BACKEND_URL}/api/plusmore/${shop}/status?idNumber=${lookupVal}&idType=${type}`);
          const fullProfileResult = await fullProfileResp.json();
          if (!fullProfileResult.success) {
            throw new Error("Failed to get membership details");
          }
          const response = fullProfileResult.data?.Response || {};
          const profileValues = response.profile_values || [];
          const cards = response.cards || [];
          const cardNoEntry = profileValues.find(pv =>
            pv.type === "plus_more_card_no" || pv.type === "card_number" || pv.type === "membership_number"
          );
          if (cardNoEntry?.value) {
            membershipNumber = String(cardNoEntry.value);
          } else if (cards.length > 0 && cards[0]?.card_number) {
            membershipNumber = cards[0].card_number;
          } else {
            const idEntry = profileValues.find(pv => pv.type === "id");
            if (idEntry?.value) membershipNumber = String(idEntry.value);
            else membershipNumber = response.guid || response.customer_id || null;
          }
        }

        if (!membershipNumber) {
          console.warn("[PlusMore Frontend] No membership number found in profile, proceeding without it");
        }

        // Update tags and metafield
        const updatePayload = { 
          plusMoreNumber: membershipNumber,
          verificationType: mode === 'phone' ? 'cell' : (mode === 'email' ? 'email' : 'id')
        };

        const tagResp = await fetch(`${BACKEND_URL}/api/plusmore/${shop}/customer/${customerId}/register`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(updatePayload)
        });

        if (!tagResp.ok) {
          const errorData = await tagResp.json().catch(() => ({}));
          
          // Handle duplicate PlusMore number (409 Conflict)
          if (tagResp.status === 409 && errorData.conflict) {
            const errorMessage = "This PlusMore number is already registered to another account";
            $("#pmStatus").textContent = errorMessage;
            return;
          }

          throw new Error("Failed to link account");
        }

        $("#pmStatus").textContent = "Account linked successfully!";

        setTimeout(() => {
          location.reload();
        }, 1000);
      } catch (err) {
        $("#pmStatus").textContent = "An error occurred. Please try again later.";
      } finally {
        $("#pmVerifyIdBtn").disabled = false;
      }
    });

    $("#pmResetBtn")?.addEventListener("click", () => {
      cachedMembershipNumber = null;
      cachedDuplicateCheck = null;
      duplicateCheckPromise = null;
      location.reload();
    });

    // Handle unlink account
    $("#pmUnlinkBtn")?.addEventListener("click", async (e) => {
      e.preventDefault();
      
      if (!confirm("Are you sure you want to unlink your +more account?")) {
        return;
      }

      try {
        const customerId = window.Shopify.customer.id;
        const shop = window.Shopify.shop;

        // Call unlink endpoint
        const tagResp = await fetch(`${BACKEND_URL}/api/plusmore/${shop}/customer/${customerId}/unlink`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({})
        });

        if (!tagResp.ok) {
          const errorData = await tagResp.json().catch(() => ({}));
          console.error("[PlusMore Frontend] Unlink failed:", {
            status: tagResp.status,
            statusText: tagResp.statusText,
            error: errorData
          });
          throw new Error(errorData.error || `Failed to unlink account (${tagResp.status})`);
        }

        location.reload();
      } catch (err) {
        alert(`An error occurred. Please try again later.`);
      }
    });
  }

  function initPmRegistrationModal() {
    const modal = document.getElementById("pmRegistrationModal");
    const iframe = document.getElementById("pmRegistrationIframe");
    const closeBtn = document.getElementById("pmRegistrationClose");
    if (!modal || !iframe) return;

    function openRegistrationModal(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      const registrationUrl = iframe.getAttribute("data-src");
      if (registrationUrl && iframe.getAttribute("src") !== registrationUrl) {
        iframe.setAttribute("src", registrationUrl);
      }
      modal.setAttribute("aria-hidden", "false");
      modal.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }

    function closeRegistrationModal() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-pm-registration-open], #pmRegistrationOpen");
      if (trigger) openRegistrationModal(event);
    });

    closeBtn?.addEventListener("click", closeRegistrationModal);

    modal.addEventListener("click", (event) => {
      if (event.target === modal) closeRegistrationModal();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && modal.classList.contains("is-open")) {
        closeRegistrationModal();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    init();
    initPmRegistrationModal();
  });
})();